import { httpService } from "./httpService";
import GenericService from "./genericService";
import { ListItem } from "../models/ListItem";
import { Complementary } from "../models/complementaries.model";

class ComplementaryService extends GenericService<Complementary, ListItem> {
    constructor() {
        super('/api/Complementary');
    }

    async getByRoomId(roomId: number | string): Promise<ListItem[]> {
        return await httpService.get<ListItem[]>(`/api/Complementary/GetByRoomId/${roomId}`, undefined, { unwrap: true, normalize: true, toast: false, });
    }
}
export const complementaryService = new ComplementaryService();